/**
 * 向量 v1 到 向量 v2 夹角的方向
 * @param  {Array} v1 向量
 * @param  {Array} v2 向量
 * @return {Boolean} >= 0 顺时针 < 0 逆时针
 */
export function direction(v1, v2) {
    return v1[0] * v2[1] - v2[0] * v1[1];
}
//# sourceMappingURL=direction.js.map